import moment from 'moment';

import {uncapitalizeMomentString} from 'nutshell-core/date-time';
import {formatTimestampHybrid} from 'nutshell-core/date-time/formatting';

import {RELATIVE_TIMESTAMP_FORMATS} from './types';
import type {RelativeTimestampFormat} from './types';

type Args = {
    datetime: number | null | undefined;
    format?: RelativeTimestampFormat;
    hideAgoString?: boolean;
    lowercase?: boolean;
    customSuffix?: string;
};

export function formatRelativeTimestamp(args: Args): string | null | undefined {
    const {datetime, hideAgoString, lowercase, customSuffix} = args;
    const format: RelativeTimestampFormat = args.format || 'fromNow';

    if (typeof datetime === 'undefined' || datetime === null) {
        return null;
    }

    const datetimeValue = moment.unix(datetime);
    if (!datetimeValue.isValid()) {
        return null;
    }

    let timestamp: string | null | undefined = null;

    switch (format) {
        case RELATIVE_TIMESTAMP_FORMATS.FROM_NOW:
            timestamp = datetimeValue.fromNow(hideAgoString);
            break;
        case RELATIVE_TIMESTAMP_FORMATS.TO_NOW:
            timestamp = datetimeValue.toNow(hideAgoString);
            break;
        case RELATIVE_TIMESTAMP_FORMATS.CALENDAR:
            // @ts-expect-error
            timestamp = datetimeValue.calendar(hideAgoString);
            break;
        case RELATIVE_TIMESTAMP_FORMATS.HOUR_HYBRID:
            timestamp = formatTimestampHybrid(datetime, {
                unitOfTime: 'minutes',
                amount: 59,
                hideAgoString,
            });
            break;
    }

    if (customSuffix && timestamp) {
        timestamp = hideAgoString
            ? `${timestamp} ${customSuffix}`
            : timestamp.replace(/\sago$/, ` ${customSuffix}`);
    }

    if (lowercase && timestamp) {
        timestamp = uncapitalizeMomentString(timestamp);
    }

    return timestamp;
}
